import type { AppAbilityRule } from '@shared/types/ability';
import { hasExplicitPermissionRule } from '@features/authorization';

export function canOpenIntegrationSettings(
  pathname: string,
  locale: string,
  permissions: readonly AppAbilityRule[] | null | undefined
): boolean {
  return (
    [
      `/${locale}/admin`,
      `/${locale}/admin/settings`,
      `/${locale}/admin/settings/helpdesk`,
      `/${locale}/admin/settings/operations/integrations`,
      `/${locale}/admin/settings/operations/integrations/klaviyo`,
      `/${locale}/admin/settings/operations/integrations/revenuecat`,
    ].includes(pathname.replace(/\/$/u, '')) &&
    hasExplicitPermissionRule(permissions, 'read', 'AdminTools')
  );
}
